// extracted by mini-css-extract-plugin
export default {"root":"SocialLinks_root__518qk","link":"SocialLinks_link__CcJbA","icon":"SocialLinks_icon__TXqGH"};